/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SigningSignRequestDto
 */
export interface SigningSignRequestDto {
    /**
     * 
     * @type {string}
     * @memberof SigningSignRequestDto
     */
    signingSessionId: string;
    /**
     * The 6-digit SMS OTP code
     * @type {string}
     * @memberof SigningSignRequestDto
     */
    otpCode: string;
}

/**
 * Check if a given object implements the SigningSignRequestDto interface.
 */
export function instanceOfSigningSignRequestDto(value: object): value is SigningSignRequestDto {
    if (!('signingSessionId' in value) || value['signingSessionId'] === undefined) return false;
    if (!('otpCode' in value) || value['otpCode'] === undefined) return false;
    return true;
}

export function SigningSignRequestDtoFromJSON(json: any): SigningSignRequestDto {
    return SigningSignRequestDtoFromJSONTyped(json, false);
}

export function SigningSignRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SigningSignRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'signingSessionId': json['signingSessionId'],
        'otpCode': json['otpCode'],
    };
}

export function SigningSignRequestDtoToJSON(json: any): SigningSignRequestDto {
    return SigningSignRequestDtoToJSONTyped(json, false);
}

export function SigningSignRequestDtoToJSONTyped(value?: SigningSignRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'signingSessionId': value['signingSessionId'],
        'otpCode': value['otpCode'],
    };
}

